module.exports = __webpack_public_path__ + "img/第2.b85b939d.png";